import { marked } from 'marked';

export function preprocessRichHtml(initData: string): string {
  // Replace math blocks first so markdown parsing doesn’t swallow them
  const replaced = initData
    .replace(
      /(^|\n)\s*\$\$([\s\S]+?)\$\$\s*(;[^\n]*)?(?=\n|$)/g,
      (_m, leading, formula, comment = '') => {
        const safeFormula = formula
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');

        const safeComment = (comment || '')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');

        return (
          `${leading}<div data-type="math-block" ` +
          `formula="${safeFormula.trim()}" ` +
          `comment="${safeComment.trim()}"></div>\n`
        );
      },
    )
    .replace(/\$(.+?)\$/g, (_m, formula) => {
      const safe = formula
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      return `<span data-type="math-inline" formula="${safe.trim()}"></span>`;
    });

  // Convert to HTML
  return marked(replaced, {
    gfm: true, // GitHub-flavored markdown (tables, task lists, etc.)
    breaks: true, // single newlines become <br>
  }) as string;
}
